if (!customElements.get("sticky-atc-bar")) {
  customElements.define(
    "sticky-atc-bar",
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add("sticky-atc-bar-enabled");

        this.selectors = {
          variantIdSelect: '[name="id"]',
        };
      }

      get quantityInput() {
        return this.querySelector("quantity-input input");
      }
      get quantity() {
        return this.querySelector("quantity-input");
      }
      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
      get productId() {
        return this.getAttribute("data-product-id");
      }
      get productForm() {
        return this.querySelector('form[is="product-form"]');
      }

      connectedCallback() {
        this.productFormActions = document.querySelector(
          `.main-product-form[data-product-id="${this.productId}"]`
        );
        this.mainProductInfo = document.querySelector(
          `product-info[data-product-id="${this.productId}"]`
        );
        this.container = this.closest(".sticky-atc-bar");
        this.submitButton = this.querySelector('[type="submit"]');
        this.selectedVariantId = this.querySelector(
          this.selectors.variantIdSelect
        ).value;

        this.variantData = this.getVariantData();

        if (window.unifiedPriceManager) {
          window.unifiedPriceManager.registerComponent("sticky-atc-bar", this);
        }

        this.init();

        this.currentVariant = this.variantData.find(
          (variant) => variant.id === Number(this.selectedVariantId)
        );
        if (!this.currentVariant) {
          this.currentVariant = this.variantData[0];
        }

        this.updatePrice();

        this.updateButton(true, "", false);
        if (!this.currentVariant) {
          this.updateButton(true, "", true);
        } else {
          this.updateButton(
            !this.currentVariant.available,
            FoxTheme.variantStrings.soldOut
          );
        }
        this.initQuantitySync();
        this.initWarrantySync();
        const hasRequiredFields = this.validateMainProductRequiredFields();
        if (hasRequiredFields) {
          this.submitButton.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.productFormActions.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
            setTimeout(() => {
              this.productFormActions.requestSubmit();
            }, 300);
          });
        } else {
          this.submitButton.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.handleStickyFormSubmit();
          });
        }
      }

      validateMainProductRequiredFields() {
        const mainForm = this.mainProductInfo;
        if (!mainForm) return true;
        const requiredFields = mainForm.querySelectorAll(
          "[data-custom-property]"
        );
        return requiredFields.length > 0;
      }

      async handleStickyFormSubmit() {
        try {
          const result = await window.UnifiedCartManager.handleFormSubmit(
            this.productForm,
            {
              source: "sticky-atc-bar",
              successCallback: (data) => {},
              errorCallback: (error) => {},
            }
          );

          return result;
        } catch (error) {
          return { success: false, error: error.message };
        }
      }

      updateQuantityInput() {
        this.updatePrice();
      }

      initQuantitySync() {
        const stickyQuantityInput = this.querySelector(
          'input[name="quantity"]'
        );
        const mainQuantityInput = document.querySelector(
          `input[name="quantity"]:not([form*="sticky"])`
        );

        if (stickyQuantityInput && mainQuantityInput) {
          let isSyncing = false;
          const syncQuantity = (
            sourceInput,
            targetInput,
            triggerEvent = true
          ) => {
            if (isSyncing) return;
            isSyncing = true;

            const value = sourceInput.value;
            targetInput.value = value;

            if (triggerEvent) {
              setTimeout(() => {
                const quantityEvent = new CustomEvent("quantity:change", {
                  detail: {
                    value: parseInt(value) || 1,
                    element: sourceInput,
                  },
                  bubbles: true,
                });
                sourceInput.dispatchEvent(quantityEvent);

                sourceInput.dispatchEvent(
                  new Event("change", { bubbles: true })
                );
              }, 10);
            }

            setTimeout(() => {
              isSyncing = false;
            }, 50);
          };

          mainQuantityInput.addEventListener("change", () => {
            if (!isSyncing) {
              syncQuantity(mainQuantityInput, stickyQuantityInput);
            }
          });

          mainQuantityInput.addEventListener("input", () => {
            if (!isSyncing) {
              syncQuantity(mainQuantityInput, stickyQuantityInput);
            }
          });

          stickyQuantityInput.addEventListener("change", () => {
            if (!isSyncing) {
              syncQuantity(stickyQuantityInput, mainQuantityInput);
            }
          });

          stickyQuantityInput.addEventListener("input", () => {
            if (!isSyncing) {
              syncQuantity(stickyQuantityInput, mainQuantityInput);
            }
          });

          if (mainQuantityInput.value) {
            stickyQuantityInput.value = mainQuantityInput.value;
          }
        }
      }

      getVariantData() {
        if (window.product?.variants && window.product.variants.length > 0) {
          this.variantData = window.product.variants;
        } else {
          this.variantData =
            this.variantData ||
            JSON.parse(
              this.container.querySelector('[type="application/json"]')
                .textContent
            );
        }
        return this.variantData;
      }

      init() {
        if (!this.productFormActions) {
          return;
        }

        this.updateStickyBarVisibility(false);

        this.isInitialized = false;
        this.lastVisibilityState = false;
        this.debounceTimer = null;
        this.scrollThreshold = 100;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.checkDevice.bind(this);
        this.checkDevice();

        this.debounce = (func, wait) => {
          return (...args) => {
            clearTimeout(this.debounceTimer);
            this.debounceTimer = setTimeout(() => func.apply(this, args), wait);
          };
        };

        this.handleScroll = this.debounce(() => {
          const scrollTop =
            window.pageYOffset || document.documentElement.scrollTop;

          let shouldShow;

          if (scrollTop <= this.scrollThreshold) {
            shouldShow = false;
          } else {
            const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
            if (mql.matches && this.mainProductInfo) {
              // 移动端：当 product-info 不在视口内时才显示
              const productInfoRect =
                this.mainProductInfo.getBoundingClientRect();
              const isProductInfoVisible =
                productInfoRect.top < window.innerHeight &&
                productInfoRect.bottom > 0;
              if (isProductInfoVisible) {
                shouldShow = false;
              } else {
                if (this.productFormActions) {
                  const rect = this.productFormActions.getBoundingClientRect();
                  const isProductFormVisible =
                    rect.top < window.innerHeight && rect.bottom > 0;
                  shouldShow = !isProductFormVisible;
                } else {
                  shouldShow = true;
                }
              }
            } else {
              // PC 端：同样以 product-info 是否完全离开视口为准
              if (this.mainProductInfo) {
                const productInfoRect =
                  this.mainProductInfo.getBoundingClientRect();
                const isProductInfoVisible =
                  productInfoRect.top < window.innerHeight &&
                  productInfoRect.bottom > 0;

                if (isProductInfoVisible) {
                  shouldShow = false;
                } else if (this.productFormActions) {
                  const rect = this.productFormActions.getBoundingClientRect();
                  const isProductFormVisible =
                    rect.top < window.innerHeight && rect.bottom > 0;
                  shouldShow = !isProductFormVisible;
                } else {
                  shouldShow = true;
                }
              } else if (this.productFormActions) {
                const rect = this.productFormActions.getBoundingClientRect();
                const isProductFormVisible =
                  rect.top < window.innerHeight && rect.bottom > 0;
                shouldShow = !isProductFormVisible;
              } else {
                shouldShow = true;
              }
            }
          }

          if (shouldShow === this.lastVisibilityState) {
            return;
          }

          this.lastVisibilityState = shouldShow;
          this.updateStickyBarVisibility(shouldShow);
        }, 50);

        window.addEventListener("scroll", this.handleScroll, { passive: true });

        this.handleScroll();

        this.initFooterObserver();
        this.syncWithMainProductForm();
      }

      initFooterObserver() {
        const mql = window.matchMedia("(min-width: 768px)");
        if (!mql.matches) return;

        const footer = document.querySelector(
          'footer, .footer, [data-section-type="footer"]'
        );
        if (!footer) return;

        this.footerObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.updateStickyBarVisibility(false);
              }
            });
          },
          { threshold: 0, rootMargin: "0px 0px -100px 0px" }
        );

        this.footerObserver.observe(footer);
      }

      updateStickyBarVisibility(shouldShow) {
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;

        const method = shouldShow ? "add" : "remove";
        this.container.classList[method]("sticky-atc-bar--show");
      }

      checkDevice(e) {
        document.documentElement.style.setProperty(
          "--sticky-atc-bar-height",
          this.clientHeight + "px"
        );
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector("#product-form-sticky-atc-bar");
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;

        const addButtonText = addButton.querySelector("span");
        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");
          addButtonText.textContent = FoxTheme.variantStrings.addToCart;
        }
      }

      updatePrice() {
        if (
          window.unifiedPriceManager &&
          window.unifiedPriceManager.isInitialized
        ) {
          const prices = window.unifiedPriceManager.getCurrentPrices();
          if (prices) {
            this.updatePriceDisplay(
              prices.totalPrice,
              prices.totalComparePrice
            );
            return;
          }
        }
      }

      updatePriceDisplay(totalPrice, totalCompareAtPrice) {
        const priceElement = this.querySelector(
          ".f-price-item--sale, .f-price-item--regular, [data-price-current]"
        );
        let comparePriceElement = this.querySelector(
          ".f-price-item--regular, [data-price-original]"
        );

        if (!comparePriceElement) {
          const priceContainer = this.querySelector(
            ".f-price__container, .f-price"
          );
          if (priceContainer) {
            comparePriceElement = document.createElement("span");
            comparePriceElement.className =
              "f-price-item f-price-item--regular";
            comparePriceElement.setAttribute("data-price-original", "");
            comparePriceElement.innerHTML = "<s></s>";
            priceContainer.appendChild(comparePriceElement);
          }
        }
        if (priceElement) {
          priceElement.textContent = totalPrice;
        }
        if (comparePriceElement) {
          const sElement = comparePriceElement.querySelector("s");
          if (sElement) {
            sElement.textContent = totalCompareAtPrice;
          } else {
            comparePriceElement.textContent = totalCompareAtPrice;
          }
          comparePriceElement.style.display = "inline";
          comparePriceElement.style.visibility = "visible";
          comparePriceElement.style.opacity = "1";
        }
      }

      getQuantity() {
        const stickyQuantityInput = this.querySelector(
          'input[name="quantity"]'
        );
        return parseInt(stickyQuantityInput?.value) || 1;
      }

      syncWarrantyProperties(warrantyDetail) {
        const warrantyProperty = this.querySelector(
          "[data-warranty-property-sticky]"
        );
        const warrantyPrice = this.querySelector(
          "[data-warranty-price-sticky]"
        );
        const warrantyActive = this.querySelector(
          "[data-warranty-active-sticky]"
        );

        if (warrantyProperty && warrantyPrice && warrantyActive) {
          if (warrantyDetail.selected) {
            const planValue = warrantyDetail.title || "Unknown warranty plan";
            const priceValue = warrantyDetail.price || 0;
            warrantyProperty.value = planValue;
            warrantyPrice.value = priceValue;
            warrantyActive.value = "true";
          } else {
            warrantyProperty.value = "";
            warrantyPrice.value = "";
            warrantyActive.value = "true";
          }
        }
      }

      initWarrantySync() {
        setTimeout(() => {
          const mainWarrantySelector = document.querySelector(
            "[data-warranty-selector]"
          );
          if (mainWarrantySelector) {
            const selectedWarranty = mainWarrantySelector.querySelector(
              ".warranty-selector__input:checked"
            );
            if (selectedWarranty) {
              const warrantyDetail = {
                selected: true,
                title:
                  selectedWarranty.dataset.warrantyTitle ||
                  "Unknown warranty plan",
                price: Number(selectedWarranty.dataset.price) || 0,
                comparePrice:
                  Number(selectedWarranty.dataset.comparePrice) || 0,
              };
              this.syncWarrantyProperties(warrantyDetail);
            }
          }
        }, 100);
      }

      syncWithMainProductForm() {
        FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
          (event) => {
            const isMainProduct =
              event.data.sectionId === this.mainProductInfo.dataset.section;
            if (!isMainProduct) return;
            const variant = event.data.variant;
            const variantInput = this.querySelector('[name="id"]');

            if (variant.price !== undefined && variant.price !== null) {
              this.currentVariant = variant;
            } else {
              if (window.product?.variants) {
                const completeVariant = window.product.variants.find(
                  (v) => v.id == variant.id
                );
                if (completeVariant) {
                  this.currentVariant = completeVariant;
                } else {
                  this.currentVariant = variant;
                }
              } else {
                this.currentVariant = variant;
              }
            }
            if (variantInput && variant) {
              variantInput.value = variant.id;
            }
            this.updatePrice();
            this.updateButton(true, "", false);
            if (!variant) {
              this.updateButton(true, "", true);
            } else {
              this.updateButton(
                !variant.available,
                FoxTheme.variantStrings.soldOut
              );
            }

            this.updateQuantityInput();
          }
        );
        document.addEventListener("warranty-selection-changed", (event) => {
          this.updatePrice();
          this.syncWarrantyProperties(event.detail);
        });
        document.addEventListener("quantity:change", (event) => {
          this.updatePrice();
        });
        document.addEventListener("total-price:update", (event) => {
          this.updatePrice();
        });
        document.addEventListener("unified-price:update", (event) => {
          const prices = event.detail;
          this.updatePriceDisplay(prices.totalPrice, prices.totalComparePrice);
        });
        document.addEventListener("total-price:calculated", (event) => {
          const priceData = event.detail;
          this.updatePriceDisplay(
            priceData.totalPrice,
            priceData.totalComparePrice
          );
        });
        document.addEventListener("variantsDataUpdated", (event) => {
          this.variantData = null;
          this.getVariantData();
          this.currentVariant = this.variantData.find(
            (variant) => variant.id === Number(this.selectedVariantId)
          );
          if (!this.currentVariant) {
            this.currentVariant = this.variantData[0];
          }
          this.updatePrice();
        });
      }
    }
  );
}
